import { motion } from "framer-motion";

const pillars = [
  {
    id: "pillar-1",
    num: "01",
    label: "Pilastro 01",
    title: "De-escalation dell'Asse HPA",
    body: (
      <>
        <strong className="font-semibold text-white">
          Abbattimento istantaneo del cortisolo
        </strong>{" "}
        e dell'adrenalina sierica durante il{" "}
        <strong className="font-semibold text-white">recupero strategico</strong>.
      </>
    ),
  },
  {
    id: "pillar-2",
    num: "02",
    label: "Pilastro 02",
    title: "Risintesi Endogena del GLP-1",
    body: (
      <>
        Riattivazione delle{" "}
        <strong className="font-semibold text-white">matrici lipofile</strong> per
        innescare la{" "}
        <strong className="font-semibold text-white">lipolisi profonda</strong> e
        spegnere la{" "}
        <strong className="font-semibold text-white">fame emotiva</strong> senza
        farmaci sintetici.
      </>
    ),
  },
  {
    id: "pillar-3",
    num: "03",
    label: "Pilastro 03",
    title: "Saturazione dell'ATP Mitocondriale",
    body: (
      <>
        Fornitura di{" "}
        <strong className="font-semibold text-white">
          vettori bioenergetici bioesponibili
        </strong>{" "}
        alla{" "}
        <strong className="font-semibold text-white">corteccia prefrontale</strong>{" "}
        per eliminare la{" "}
        <strong className="font-semibold text-white">stanchezza decisionale</strong>.
      </>
    ),
  },
];

export default function Pillars() {
  return (
    <section
      id="il-metodo"
      data-testid="pillars-section"
      className="relative mx-auto max-w-7xl px-6 py-28 md:py-36"
    >
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="mb-6 flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.35em] text-[#B87333]">
          <span className="inline-block h-px w-12 bg-[#B87333]/60" />
          Il Protocollo Scientifico
        </p>
        <h2
          data-testid="pillars-title"
          className="font-serif-lux text-2xl tracking-tight text-[#D4AF37] sm:text-3xl lg:text-4xl"
        >
          IL METODO AVANZATO
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#A3A3A3] md:text-lg">
          Tre pilastri fisiologici per la risoluzione definitiva dell'attrito
          biologico executive.
        </p>
        <div className="mt-10 h-px w-full bg-gradient-to-r from-[#D4AF37]/50 via-[#D4AF37]/15 to-transparent" />
      </motion.div>

      <div className="mt-4">
        {pillars.map((p, i) => (
          <motion.article
            key={p.id}
            data-testid={p.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="group grid gap-6 border-b border-[#D4AF37]/10 py-14 transition-colors duration-500 hover:bg-[#141414]/40 md:grid-cols-[140px_1fr_1.4fr] md:items-baseline md:gap-12"
          >
            <span className="font-serif-lux text-6xl leading-none text-[#D4AF37]/25 transition-colors duration-500 group-hover:text-[#D4AF37]/45 md:text-7xl">
              {p.num}
            </span>
            <div>
              <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-[#737373]">
                {p.label}
              </p>
              <h3 className="font-serif-lux text-xl text-[#D4AF37] sm:text-2xl">
                {p.title}
              </h3>
            </div>
            <p className="text-base leading-relaxed text-[#A3A3A3]">{p.body}</p>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
